import { motion } from "framer-motion";

const WA_PHONE = "628112002352";
const WA_TEXT = encodeURIComponent(
  "Assalamualaikum wr.wb ... hallo admin Pondok Tahfizh Generasi Rabbani Qurani! saya ingin menanyakan sesuatu seputar Pondok Tahfizh Generasi Rabbani Qurani!"
);
export const WA_LINK = `https://wa.me/${WA_PHONE}?text=${WA_TEXT}`;

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat WhatsApp Admin Pondok Tahfizh Generasi Rabbani Qurani"
      data-testid="floating-whatsapp"
      initial={{ opacity: 0, scale: 0.5, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group flex items-center gap-3"
    >
      {/* Pulse ring */}
      <span className="absolute right-0 w-14 h-14 rounded-full bg-[#25D366] opacity-50 animate-ping" />

      {/* Label (desktop only) */}
      <span className="hidden md:inline-flex items-center px-4 py-2 rounded-full bg-forest text-parchment text-xs shadow-lg opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500 whitespace-nowrap pointer-events-none">
        Chat WhatsApp Admin
      </span>

      {/* Button */}
      <span className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl ring-4 ring-[#25D366]/20 hover:bg-[#1ebe57] transition-colors duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          className="w-7 h-7"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.42-1.42.066-.245.122-.587.122-.92 0-.715-.215-.787-.6-1.018-.5-.286-.93-.473-1.405-.687-.214-.115-.616-.473-.802-.473ZM16.114 25.5c-1.535 0-3.025-.4-4.34-1.16l-.302-.184-3.16.83.832-3.07-.215-.317c-.846-1.347-1.318-2.94-1.318-4.547 0-4.677 3.81-8.486 8.486-8.486 4.69 0 8.486 3.81 8.486 8.486 0 4.674-3.81 8.486-8.486 8.486l.017-.038ZM16.114 5.6C9.978 5.6 5 10.577 5 16.715c0 1.95.515 3.882 1.49 5.575L5 28l5.875-1.547a11.04 11.04 0 0 0 5.24 1.332h.014c6.115 0 11.4-4.977 11.4-11.116 0-2.97-1.346-5.762-3.355-7.86-2.005-2.107-4.797-3.21-7.066-3.21Z" />
        </svg>
      </span>
    </motion.a>
  );
}
